import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-164">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-165" />

      {/* Modal */}
      <div className="relative z-10 bg-white w-full max-w-2xl max-h-[85vh] flex flex-col shadow-2xl" data-id="element-166">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-6 border-b border-stone-100 shrink-0" data-id="element-167">
          <h2 id="modal-title" className="text-2xl font-serif font-bold text-stone-900" data-id="element-168">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-stone-400 hover:text-stone-900 hover:bg-stone-100 rounded-full transition-colors duration-200" aria-label="Cerrar" data-id="element-169">
            <X className="w-5 h-5" data-id="element-170" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto px-8 py-6 text-stone-600 text-sm leading-relaxed space-y-6" data-id="element-171">
          {children}
        </div>

        {/* Footer */}
        <div className="px-8 py-4 border-t border-stone-100 shrink-0 text-center" data-id="element-172">
          <button onClick={onClose} className="text-xs text-stone-400 hover:text-stone-900 uppercase tracking-widest transition-colors duration-200" data-id="element-173">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}